export const DetectiveZoneModal = {
    render() {
        if (document.getElementById('detectiveZoneModal')) return;
        const html = `
        <div id="detectiveZoneModal" class="modal hidden">
            <div class="modal-content" style="max-width: 650px; padding: 2.5rem; text-align: center; border-radius: 24px; background: linear-gradient(to bottom, #f8fafc, #f1f5f9);">
                <div style="width: 100%; display: flex; justify-content: flex-start; margin-bottom: 20px;">
                    <button class="btn-atras-unificado" id="dz-close-btn">⬅️ ATRÁS</button>
                </div>
                <h2 style="font-size: 2rem; margin-bottom: 0.5rem; color: #1e293b; font-weight: 900;">⭐ ZONA SECRETA</h2>
                <p style="color: #64748b; margin-bottom: 2rem; font-size: 1.2rem;">Tu cuartel general. ¿Qué necesitas?</p>
                
                <!-- Opciones Principales de la Zona -->
                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(110px, 1fr)); gap: 15px; margin-bottom: 2rem;">
                    <button id="dz-map-btn" class="btn btn-secondary" style="height: 120px; padding: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; background: #22d3ee; color: #000; font-weight: 900; border-radius: 16px; box-sizing: border-box;">
                        <span style="font-size: 2.5rem; margin-bottom: 8px; line-height: 1;">🗺️</span>
                        <span style="line-height: 1; text-align: center;">MAPA</span>
                    </button>
                    <button id="dz-store-btn" class="btn btn-secondary" style="height: 120px; padding: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; background: linear-gradient(135deg, #F59E0B, #D97706); color: #000; font-weight: 900; border-radius: 16px; box-sizing: border-box;">
                        <span style="font-size: 2.5rem; margin-bottom: 8px; line-height: 1;">🏪</span>
                        <span style="line-height: 1; text-align: center;">TIENDA</span>
                    </button>
                    <button id="dz-guide-btn" class="btn btn-primary" style="height: 120px; padding: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; background: linear-gradient(135deg, #4338ca, #3730a3); color: #FFF; font-weight: 900; border-radius: 16px; box-sizing: border-box;">
                        <span style="font-size: 2.5rem; margin-bottom: 8px; line-height: 1;">❓</span>
                        <span style="line-height: 1; text-align: center;">AYUDA</span>
                    </button>
                    <button id="dz-profile-btn" class="btn btn-secondary" style="height: 120px; padding: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; background: linear-gradient(135deg, #10B981, #059669); color: #FFF; font-weight: 900; border-radius: 16px; box-sizing: border-box;">
                        <span style="font-size: 2.5rem; margin-bottom: 8px; line-height: 1;">👤</span>
                        <span style="line-height: 1; text-align: center;">MI PERFIL</span>
                    </button>
                </div>

                <!-- Opciones Extra / Configuración (ELIMINADAS y movidas a Gestión) -->
            </div>
        </div>`;
        document.body.insertAdjacentHTML('beforeend', html);
        
        // Event Listeners
        document.getElementById('dz-close-btn').addEventListener('click', () => this.close());
        
        // Helper to check user session
        const requireLogin = () => {
            if (!window.UserManager || !window.UserManager.currentUser) {
                this.close();
                alert('¡Primero entra en "Soy un Detective" para elegir tu personaje!');
                if (window.showLoginScreen) window.showLoginScreen(true);
                return false;
            }
            return true;
        };

        // Captures current screen to restore it later
        const captureCurrentScreen = () => {
            const activeScreen = document.querySelector('.screen.active');
            return activeScreen ? activeScreen.id : 'welcomeScreen';
        };

        const restoreScreenCallback = (screenId) => {
            return () => {
                if (window.SessionManager) window.SessionManager.hideAllScreens();
                const screen = document.getElementById(screenId);
                if (screen) {
                    screen.classList.remove('hidden');
                    screen.classList.add('active');
                }
                if (window.SessionManager) window.SessionManager.updateGlobalNavButtons();
            };
        };

        // Core Actions
        document.getElementById('dz-map-btn').addEventListener('click', () => {
            if (!requireLogin()) return;
            const previousScreenId = captureCurrentScreen();
            this.close();
            if (window.showMapScreen) window.showMapScreen(restoreScreenCallback(previousScreenId));
        });
        
        document.getElementById('dz-store-btn').addEventListener('click', () => {
            if (!requireLogin()) return;
            const previousScreenId = captureCurrentScreen();
            this.close();
            if (window.StickerStore) window.StickerStore.openStore(restoreScreenCallback(previousScreenId));
        });
        
        document.getElementById('dz-guide-btn').addEventListener('click', () => {
            this.close();
            if (window.AppGuide) window.AppGuide.open();
        });
        
        document.getElementById('dz-profile-btn').addEventListener('click', () => {
            if (!requireLogin()) return;
            this.close();
            if (window.showProfileModal) window.showProfileModal();
        });

        // Opciones Extra han sido eliminadas y reubicadas.
        // Escape key listener
        this._handleKeyDown = (e) => {
            if (e.key === 'Escape') this.close();
        };
    },

    open() {
        this.render();
        document.getElementById('detectiveZoneModal').classList.remove('hidden');
        document.addEventListener('keydown', this._handleKeyDown);
        if (window.AccessibilityManager) {
            window.AccessibilityManager.trapFocus(document.getElementById('detectiveZoneModal'));
            window.AccessibilityManager.announce("Zona Detective abierta. Selecciona mapa, tienda, ayuda o más opciones.");
        }
    },

    close() {
        const modal = document.getElementById('detectiveZoneModal');
        if (modal) modal.classList.add('hidden');
        document.removeEventListener('keydown', this._handleKeyDown);
    }
};

if (typeof window !== 'undefined') {
    window.DetectiveZoneModal = DetectiveZoneModal;
}
